import { ConfiguratorTextfieldEffects } from './configurator-textfield.effect';

export const configuratorTextfieldEffects: any[] = [
  ConfiguratorTextfieldEffects,
];

export * from './configurator-textfield.effect';
